export default __webpack_public_path__ + "static/media/scrabble-1920w.71c2ee33.webp";